import { GridColumn, GridRow } from "@vfuk/core-grid";
import Heading from "@vfuk/core-heading";
import Spacing from "@vfuk/core-spacing";

import "../../assets/styles/common.scss";

export type TableModalContentProps = {
  message: string;
  body: {
    name: string;
    displayName: string;
    data: {
      rateOnDate: string;
      rates: Array<{ currencyPair: string; rate: string }>;
    };
  } | null;
  loading?: boolean;
};

export const TableModalContent = (
  props: TableModalContentProps
): JSX.Element => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const showFormattedDate = (timeStrap: string) => {
    if (!props.body) return;
    const yearArray = new Date(parseInt(props.body.data.rateOnDate) * 1000)
      .getFullYear()
      .toString()
      .split("");
    let returnData: string =
      new Date(parseInt(props.body.data.rateOnDate) * 1000).toLocaleString(
        "default",
        { month: "short" }
      ) + " ";
    returnData += yearArray[2] + yearArray[3];
    return returnData;
  };
  return (
    <>
      <div role="dialog">
        <Spacing spacingLevel={{ top: 4, left: 7, right: 7 }}>
          <div className="modalMessage centerAlign">
            {props.body?.displayName}
          </div>
        </Spacing>
        <Spacing spacingLevel={{ top: 3, bottom: 5 }}>
          <div className="modalSubmessage">
            <GridRow marginBottom={3} marginTop={3}>
              <GridColumn col={3}>
                <Heading size={1} text={"Currency"} weight={2} />
              </GridColumn>
              <GridColumn col={3}>
                <Heading
                  size={1}
                  text={
                    "Rate(" +
                    showFormattedDate(props.body?.data.rateOnDate || "") +
                    ")"
                  }
                  weight={2}
                />
              </GridColumn>
              <GridColumn col={3}>
                <Heading size={1} text={"Currency"} weight={2} />
              </GridColumn>
              <GridColumn col={3}>
                <Heading
                  size={1}
                  text={
                    "Rate(" +
                    showFormattedDate(props.body?.data.rateOnDate || "") +
                    ")"
                  }
                  weight={2}
                />
              </GridColumn>
              {props.body?.data.rates.map((value) => (
                <>
                  <GridColumn col={3}>{value.currencyPair}</GridColumn>
                  <GridColumn col={3}>{value.rate}</GridColumn>
                </>
              ))}
            </GridRow>
          </div>
        </Spacing>
      </div>
    </>
  );
};
